/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Background_SyncInputs */

const en_svchip_background_sync = /** @type {(inputs: Svchip_Background_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Background sync`)
};

const ar_svchip_background_sync = /** @type {(inputs: Svchip_Background_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مزامنة خلفية`)
};

const bn_svchip_background_sync = /** @type {(inputs: Svchip_Background_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ব্যাকগ্রাউন্ড সিঙ্ক`)
};

const de_svchip_background_sync = /** @type {(inputs: Svchip_Background_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hintergrundsynchronisierung`)
};

const es_svchip_background_sync = /** @type {(inputs: Svchip_Background_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronización en segundo plano`)
};

const fr_svchip_background_sync = /** @type {(inputs: Svchip_Background_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchronisation en arrière-plan`)
};

const pt_svchip_background_sync = /** @type {(inputs: Svchip_Background_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronização em segundo plano`)
};

const zh_svchip_background_sync = /** @type {(inputs: Svchip_Background_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`后台同步`)
};

const tr_svchip_background_sync = /** @type {(inputs: Svchip_Background_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arka planda senkronizasyon`)
};

const ru_svchip_background_sync = /** @type {(inputs: Svchip_Background_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фоновая синхронизация`)
};

const pl_svchip_background_sync = /** @type {(inputs: Svchip_Background_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchronizacja w tle`)
};

/**
* | output |
* | --- |
* | "Background sync" |
*
* @param {Svchip_Background_SyncInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_background_sync = /** @type {((inputs?: Svchip_Background_SyncInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Background_SyncInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_background_sync(inputs)
	if (locale === "bn") return bn_svchip_background_sync(inputs)
	if (locale === "de") return de_svchip_background_sync(inputs)
	if (locale === "es") return es_svchip_background_sync(inputs)
	if (locale === "fr") return fr_svchip_background_sync(inputs)
	if (locale === "pt") return pt_svchip_background_sync(inputs)
	if (locale === "zh") return zh_svchip_background_sync(inputs)
	if (locale === "tr") return tr_svchip_background_sync(inputs)
	if (locale === "ru") return ru_svchip_background_sync(inputs)
	if (locale === "pl") return pl_svchip_background_sync(inputs)
	return en_svchip_background_sync(inputs)
});